import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

export default function setBannersLinha() {
  const sections = document.querySelectorAll('[data-banner-linha]');

  sections.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');
    const quantity = carousel.getAttribute('data-banner-quantity');

    if (carousel) {
      if (carousel.swiper) {
        carousel.swiper.destroy(true, true);
      }

      new Swiper(carousel, {
        modules: [Pagination, Autoplay],

        loop: false,
        rewind: true,
        watchOverflow: false,

        slidesPerView: 1.2,
        spaceBetween: 8,

        speed: 800,

        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },

        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },

        breakpoints: {
          768: {
            slidesPerView: carousel.classList.contains('multiple') ? 4.2 : 2,
            spaceBetween: 8,
          },
          992: {
            slidesPerView: carousel.classList.contains('multiple') ? 5.2 : quantity,
            spaceBetween: 8,
          },
        },
      });
    }
  });
}
